__turbopack_context__.v({
  "button": "ek0_nG_button",
  "currency": "ek0_nG_currency",
  "desktopToolTip": "ek0_nG_desktopToolTip",
  "input": "ek0_nG_input",
  "inputWrapper": "ek0_nG_inputWrapper",
  "invalid": "ek0_nG_invalid",
  "invalidMsg": "ek0_nG_invalidMsg",
  "percentage": "ek0_nG_percentage",
  "tooltip": "ek0_nG_tooltip",
});
